import axios from "axios";
import { customerApi } from "./customerApi";
import { resolveConsumerApiBaseUrl } from "./consumerApiConfig";
import { clearCsrfToken, getCsrfToken, setCsrfToken, shouldAttachCsrf } from "./csrf";

const baseURL = resolveConsumerApiBaseUrl(process.env, {
  allowHttpLoopback: process.env.NODE_ENV !== "production",
});

export const consumerApi = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

consumerApi.interceptors.request.use((config) => {
  const headers = config.headers || {};
  // Never attach bearer credentials for customer identity — cookie session only.
  if (headers.Authorization || headers.authorization) {
    delete headers.Authorization;
    delete headers.authorization;
  }
  if (shouldAttachCsrf(config.method)) {
    const token = getCsrfToken();
    if (token) {
      headers["X-CSRF-Token"] = token;
    }
  }
  config.headers = headers;
  return config;
});

export async function refreshCsrfToken() {
  const { data } = await consumerApi.get("/v1/session/csrf");
  return setCsrfToken(data?.csrf_token || null);
}

export function resetConsumerApiAuthState() {
  clearCsrfToken();
}

export async function establishConsumerSession() {
  resetConsumerApiAuthState();
  const { data: challenge } = await consumerApi.get("/v1/identity/bridge/challenge");
  const { data: websiteAssertion } = await customerApi.post("/customers/consumer-bridge", {
    challenge: challenge.challenge,
  });
  await consumerApi.post("/v1/identity/bridge/exchange", {
    assertion: websiteAssertion.assertion,
  });
  await refreshCsrfToken();
  const { data: session } = await consumerApi.get("/v1/session/me");
  return session;
}

export async function endConsumerSession() {
  try {
    await refreshCsrfToken();
    await consumerApi.post("/v1/identity/logout");
  } finally {
    resetConsumerApiAuthState();
  }
}
